export default __webpack_public_path__ + "static/preasureDoctor-345446ff80e85169960fec5d313107ed.jpg";